// src/forms/local/localDepositoDesechos/createlocalDepositoForm.js
/* eslint-disable */

import React, { Component } from "react";
import PropTypes from "prop-types";
import localService from "../../../services/localService";
import {
  Button,
  TextField,
  Grid,
  Container,
  Paper,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import esLocale from "date-fns/locale/es";

import data from "../../../assets/departamentos-y-ciudades.json";
import CancelButton from "components/common/CancelButton";
import AcceptButton from "components/common/AcceptButton";
import {
  getDefaultOperationDate,
  isFutureOperationDate,
  isValidOperationDate,
  toLocalDateOnlyString,
} from "utils/operationDate";

class CreateLocalDepositoForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      local: {
        Name: "",
        Address: "",
        Department: "",
        City: "",
        Type: "Depósito", // fijo
        // LocalPersonId: null,
        Stock: null,
      },
      selectedDepartamento: "",
      selectedCiudad: "",
      submitting: false,
      creationDate: getDefaultOperationDate(),
      generalError: "",
      showRequiredErrors: false,
    };
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      local: {
        ...prevState.local,
        [name]: value,
      },
    }));
  };

  handleDepartamentoChange = (event) => {
    const selectedDepartamento = event.target.value;
    this.setState((prevState) => ({
      selectedDepartamento,
      selectedCiudad: "",
      local: {
        ...prevState.local,
        Department: selectedDepartamento,
        City: "",
      },
    }));
  };

  handleCiudadChange = (event) => {
    const selectedCiudad = event.target.value;
    this.setState((prevState) => ({
      selectedCiudad,
      local: {
        ...prevState.local,
        City: selectedCiudad,
      },
    }));
  };

  handleCreationDateChange = (date) => {
    this.setState({ creationDate: date, generalError: "" });
  };

  getCreationDateError = () => {
    const { creationDate } = this.state;
    if (!isValidOperationDate(creationDate)) return "Selecciona una fecha válida.";
    if (isFutureOperationDate(creationDate)) return "No se puede seleccionar una fecha futura.";
    return "";
  };

  getApiErrorMessage = (error, fallback) => {
    const apiCode = error?.response?.data?.code || "";
    const apiError = error?.response?.data?.error || fallback;

    if (apiCode === "EFFECTIVE_DATE_CANNOT_BE_FUTURE") {
      return "No se puede seleccionar una fecha futura.";
    }

    return apiError || fallback;
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    const { local, creationDate } = this.state;
    if (!local.Name?.trim() || !local.Address?.trim() || !local.Department || !local.City) {
      this.setState({ showRequiredErrors: true });
      return;
    }
    const creationDateError = this.getCreationDateError();
    if (creationDateError) {
      return;
    }

    this.setState({ submitting: true, generalError: "" });

    try {
      
      const created = await localService.createLocal({
        ...local,
        CreationDate: toLocalDateOnlyString(creationDate),
      });

      if (!created?.id && !created?.Id) {
        this.setState({ generalError: "No se pudo crear el depósito." });
        return;
      }

      if (typeof this.props.onCreated === "function") {
       await this.props.onCreated();
     }

      this.props.closeForm();
    } catch (error) {
      console.error(error);
      this.setState({
        generalError: this.getApiErrorMessage(error, "Error creando depósito."),
      });
    } finally {
      this.setState({ submitting: false });
    }
  };

  render() {
    const {
      local,
      selectedDepartamento,
      selectedCiudad,
      submitting,
      creationDate,
      generalError,
      showRequiredErrors,
    } = this.state;

    return (
      <Container component={Paper} style={{ padding: "20px", marginTop: "20px" }}>
        <form onSubmit={this.handleSubmit} noValidate>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Nombre"
                required
                name="Name"
                value={local.Name}
                onChange={this.handleChange}
                error={showRequiredErrors && !local.Name?.trim()}
                helperText={showRequiredErrors && !local.Name?.trim() ? "Ingresá un nombre." : ""}
              />
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth required error={showRequiredErrors && !local.Department}>
                <InputLabel>Departamento</InputLabel>
                <Select
                  value={selectedDepartamento}
                  onChange={this.handleDepartamentoChange}
                  label="Departamento"
                >
                  {data.map((d) => (
                    <MenuItem key={d.id} value={d.name}>
                      {d.name}
                    </MenuItem>
                  ))}
                </Select>
                {showRequiredErrors && !local.Department && (
                  <FormHelperText>Seleccioná un departamento.</FormHelperText>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12} md={8}>
              <TextField
                fullWidth
                label="Dirección"
                required
                name="Address"
                value={local.Address}
                onChange={this.handleChange}
                error={showRequiredErrors && !local.Address?.trim()}
                helperText={showRequiredErrors && !local.Address?.trim() ? "Ingresá una dirección." : ""}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <FormControl
                fullWidth
                required
                disabled={!selectedDepartamento}
                error={showRequiredErrors && !local.City}
                sx={showRequiredErrors && !local.City && !selectedDepartamento ? {
                  "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                    borderColor: "error.main",
                  },
                } : undefined}
              >
                <InputLabel>Ciudad</InputLabel>
                <Select
                  value={selectedCiudad}
                  onChange={this.handleCiudadChange}
                  label="Ciudad"
                >
                  {data
                    .find((d) => d.name === selectedDepartamento)
                    ?.towns.map((t) => (
                      <MenuItem key={t.id} value={t.name}>
                        {t.name}
                      </MenuItem>
                    ))}
                </Select>
                {showRequiredErrors && !local.City && (
                  <FormHelperText>
                    {selectedDepartamento ? "Seleccioná una ciudad." : "Seleccioná primero un departamento para elegir la ciudad."}
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
                <DatePicker
                  label="Fecha de creación del local"
                  value={creationDate}
                  onChange={this.handleCreationDateChange}
                  maxDate={getDefaultOperationDate()}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      required: true,
                      error: Boolean(this.getCreationDateError()),
                      helperText: this.getCreationDateError(),
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            {generalError && (
              <Grid item xs={12}>
                <Alert severity="error" onClose={() => this.setState({ generalError: "" })}>
                  {generalError}
                </Alert>
              </Grid>
            )}

            <Grid item xs={12} sx={{ mt: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <CancelButton onClick={this.props.closeForm} disabled={submitting} fullWidth>
                    Cancelar
                  </CancelButton>
                </Grid>

                <Grid item xs={12} md={6}>
                  <AcceptButton
                    type="submit"
                    disabled={submitting || Boolean(this.getCreationDateError())}
                    fullWidth
                  >
                    {submitting ? "Creando..." : "Crear depósito"}
                  </AcceptButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Container>
    );
  }
}

CreateLocalDepositoForm.propTypes = {
  closeForm: PropTypes.func.isRequired,
  onCreated: PropTypes.func,
};

export default CreateLocalDepositoForm;
